import { ExampleSchemaWithRunsAndOptionalFields } from '@/types/schema';

// transform the examples so that the inputs are unpacked as inputs, outputs, referenceOutput
export const transformAlignmentDsExamples = (
  examples: ExampleSchemaWithRunsAndOptionalFields[],
  columnId: string
): ExampleSchemaWithRunsAndOptionalFields[] => {
  return examples.map((example) => {
    return {
      ...example,
      inputs: example.inputs.input ?? example.inputs.inputs,
      outputs:
        example.inputs.referenceOutput ?? example.inputs.reference_outputs,
      runs:
        example.runs && example.runs.length > 0
          ? example.runs?.map((run) => {
              return {
                ...run,
                error: undefined,
                status: null,
                inputs: example.inputs.input ?? example.inputs.inputs,
                outputs: example.inputs.output ?? example.inputs.outputs,
              };
            })
          : [
              {
                id: example.id,
                inputs: example.inputs.input ?? example.inputs.inputs,
                outputs: example.inputs.output ?? example.inputs.outputs,
                session_id: columnId,
                run_type: 'chain',
                status: null,
                name: 'Evaluator',
                start_time: new Date().toISOString(),
                trace_id: example.id,
                dotted_order: 'N/A',
                app_path: 'N/A',
              },
            ],
    };
  });
};
